// extracted by mini-css-extract-plugin
export default {"pageTitle":"error_pageTitle__bikGd","siteWidth":"error_siteWidth__+q5WS","errorPanel":"error_errorPanel__MgxNU"};